import { useServiceType } from 'widgets/project-creation-stepper/providers/service-provider';
import { AppConfigComponent } from 'widgets/project-creation-stepper/ui/config-component/app-config';
import { CnpgComponent } from 'widgets/project-creation-stepper/ui/config-component/cnpg-config';
import { MarketplaceConfig } from 'widgets/project-creation-stepper/ui/config-component/marketplace-config';
export const ConfigComponent = () => {
  const {
    serviceType,
    selectedProjectType
  } = useServiceType();
  if (serviceType === 'db' && selectedProjectType === 'cnpg') return <CnpgComponent disabled={false} />;
  if (serviceType === 'marketplace') return <MarketplaceConfig />;
  return <AppConfigComponent data-sentry-element="AppConfigComponent" data-sentry-component="ConfigComponent" data-sentry-source-file="config-component.tsx" />;
};